var map = {
	"./music-instructions.json": 4703,
	"./music-library-intro2024.json": 4704,
	"./music-library-launch2024.json": 4705,
	"./music-progression.json": 4706,
	"./startSourcesAdvanced.json": 4707,
	"./startSourcesSimple.json": 4708,
	"./startSourcesSimple2.json": 4709,
	"./startSourcesTracks.json": 4710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4472;